import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { castPrice, Price, toGQLPrice } from "@ct-react/core";
import { useLocaleFormatter } from "@ct-react/locale";
import { BenefitCartOption, CartItemOptionInput } from "@shared/graphql";
import { form } from "../../i18n/sharable-defs";
import { useForm } from "../../hooks/form";
import Select, { Option } from "../inputs/select";
import "./options-selector.scss";

type Props = {
  config: BenefitCartOption[];
  onSelection: (options: CartItemOptionInput[]) => void;
}

const CheckoutOptionSelector = ({ config, onSelection }: Props) => {

  const intl = useIntl();
  const { print } = useLocaleFormatter();

  const formatedSelection = useCallback((value: Partial<Record<string, string>>): CartItemOptionInput<Price>[] => {
    return config.map(({ optionId, grid }) => {
      const currency = castPrice(grid[0].price).currency;
      const search = grid.find(({ quantity }) => quantity === (!!value[optionId] ? +value![optionId] : 0));
      return { optionId, price: !!search ? castPrice(search.price) : { amount: 0, currency } };
    });
  }, [ config ]);

  const { register, currentValue } = useForm<Record<string, string>>();
  const [ selection, setSelection ] = useState<CartItemOptionInput<Price>[]>(formatedSelection({}));

  useEffect(() => setSelection(formatedSelection(currentValue)), [ currentValue ]);

  useEffect(() => onSelection(selection
    .filter(({ price }) => price.amount > 0)
    .map(({ price, ...rest }) => ({ ...rest, price: toGQLPrice(price) }))
  ), [ selection ]);

  return (
    <>
      {config.map((opt: BenefitCartOption) => {
        return (
          <div key={opt.optionId} className="option-selector">
            <Select placeholder="-" {...register(opt.optionId, {
                      ...(opt.forceSelection) && { required: intl.formatMessage(form.emptyError)},
                      ...(!opt.forceSelection) && { defaultValue: 0 }
                    })}>
              {opt.criteria.quantity.map((value: number, index: number) => (
                <Option key={index} value={value} label={value.toString()} />
              ))}
            </Select>
            <span className="title">{opt.title.value}</span>
            {!!opt.description &&
              <div className="desc r-format-html" dangerouslySetInnerHTML={{ __html: opt.description.value }} />
            }
            <span className="price">{print.price(selection.find(({ optionId }) => optionId === opt.optionId)!.price)}</span>
          </div>);
      })}
    </>);

};

export default CheckoutOptionSelector;
